export default __webpack_public_path__ + "static/media/icons1.58f12f37.svg";